import { IHeaderTableForecast } from "@/types/header-forecast-table";

import iconTemp from "@/img/temp-icon.svg";
import iconWindSpeed from "@/img/wind-speed-icon.svg";
import iconWindDirection from "@/img/wind-direction-map-icon.svg";
import iconWaveHeight from "@/img/icon-weather-responsive/wave-feat-icon.svg";
import iconWaveDirection from "@/img/icon-weather-responsive/wind-direction-marine.svg";
import iconCurrentVelocity from "@/img/icon-weather-responsive/velocity-marine-icon.svg";
import iconSeaSurfaceTemp from "@/img/icon-weather-responsive/temp-sea-icon.svg";
import iconTidalElevation from "@/img/icon-weather-responsive/tide-elevation-icon.svg";
import iconWavePeriod from "@/img/icon-weather-responsive/mean-wave-period-icon.svg";

export const labelHeaderMarine: IHeaderTableForecast[] = [
	{
		key: "time",
	},
	{
		key: "airTemperature",
		icon: iconTemp,
	},
	{
		key: "Wind speed (km/h)",
		icon: iconWindSpeed,
	},
	{
		key: "windDirection",
		icon: iconWindDirection,
	},
	{
		key: "waveHeight",
		icon: iconWaveHeight,
	},
	{
		key: "meanWaveDirection",
		icon: iconWaveDirection,
	},
	{
		key: "currentVelocity",
		icon: iconCurrentVelocity,
	},
	{
		key: "meanWavePeriod",
		icon: iconWavePeriod,
	},
	{
		key: "seaSurfaceTemperature",
		icon: iconSeaSurfaceTemp,
	},
	{
		key: "tidalElevation",
		icon: iconTidalElevation,
	},
];
